/* eslint-disable indent */
import React, { useState } from 'react'
import axios from 'axios'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Alert from 'react-bootstrap/Alert'

const CANDIDATE_POSITIONS = [
  'GK',
  'WB',
  'ETWB',
  'CD',
  'CA',
  'IM',
  'W',
  'FW',
  'FTW',
  'PNF',
  'TDF',
]

const CreateListModal = ({
  show,
  onHide,
  onListCreated,
  defaultType,
  user,
}) => {
  const [activeTab, setActiveTab] = useState(defaultType || 'candidate')
  const [message, setMessage] = useState({ type: '', text: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Ehdokaslistan state
  const [teamType, setTeamType] = useState('U21')
  const [season, setSeason] = useState('')
  const [competition, setCompetition] = useState('CC')
  const [position, setPosition] = useState('GK')
  const [customPosition, setCustomPosition] = useState('')
  const [mjQualifier, setMjQualifier] = useState('')
  const [isMultiCreateMode, setIsMultiCreateMode] = useState(false)
  const [selectedPositions, setSelectedPositions] =
    useState(CANDIDATE_POSITIONS)

  // Vaatimuslistan state
  const [name, setName] = useState('')
  const [age, setAge] = useState('')
  const [keeperSkill, setKeeperSkill] = useState('')
  const [defenderSkill, setDefenderSkill] = useState('')
  const [playmakerSkill, setPlaymakerSkill] = useState('')
  const [wingerSkill, setWingerSkill] = useState('')
  const [passingSkill, setPassingSkill] = useState('')
  const [scorerSkill, setScorerSkill] = useState('')
  const [setPiecesSkill, setSetPiecesSkill] = useState('')
  const [htms, setHTMS] = useState('')

  // Päivitä välilehti kun defaultType muuttuu
  React.useEffect(() => {
    if (defaultType) {
      setActiveTab(defaultType)
    }
  }, [defaultType])

  const resetForm = () => {
    setTeamType('U21')
    setSeason('')
    setCompetition('CC')
    setPosition('GK')
    setCustomPosition('')
    setMjQualifier('')
    setIsMultiCreateMode(false)
    setSelectedPositions(CANDIDATE_POSITIONS)
    setName('')
    setAge('')
    setKeeperSkill('')
    setDefenderSkill('')
    setPlaymakerSkill('')
    setWingerSkill('')
    setPassingSkill('')
    setScorerSkill('')
    setSetPiecesSkill('')
    setHTMS('')
    setMessage({ type: '', text: '' })
  }

  const handleClose = () => {
    resetForm()
    onHide()
  }

  const handleCandidateSubmit = async event => {
    event.preventDefault()
    setIsSubmitting(true)

    if (teamType === 'U21') {
      if (!season) {
        setMessage({
          type: 'danger',
          text: 'U21-listalle pitää antaa kausinumero',
        })
        setIsSubmitting(false)
        return
      }
    }

    // Määritä pelipaikka ja käytä sitä nimenä
    const finalPosition = position === 'Muu' ? customPosition : position

    try {
      const response = await axios.post(
        '/api/candidates',
        {
          Name: finalPosition,
          TeamType: teamType,
          Season: teamType === 'U21' ? parseInt(season) : null,
          Competition: teamType === 'U21' ? competition : null,
          Position: finalPosition,
          Qualifier:
            teamType === 'MJ' && mjQualifier.trim()
              ? mjQualifier.trim()
              : undefined,
        },
        {
          headers: { 'x-oauth-token': user ? user.oauth_token : null },
        }
      )
      setMessage({
        type: 'success',
        text: `Ehdokaslista "${response.data.Name}" luotu!`,
      })
      onListCreated('candidate', response.data)
      resetForm()
      setTimeout(() => {
        handleClose()
      }, 1500)
    } catch (error) {
      console.error('Failed to create candidate list:', error)
      setMessage({ type: 'danger', text: 'Virhe luotaessa ehdokaslistaa' })
    } finally {
      setIsSubmitting(false)
    }
  }

  const handlePositionToggle = positionName => {
    setSelectedPositions(prev => {
      if (prev.includes(positionName)) {
        return prev.filter(p => p !== positionName)
      }
      return [...prev, positionName]
    })
  }

  const handleCreateMultipleCandidates = async event => {
    event.preventDefault()
    setIsSubmitting(true)

    if (teamType === 'U21' && !season) {
      setMessage({
        type: 'danger',
        text: 'U21-listalle pitää antaa kausinumero',
      })
      setIsSubmitting(false)
      return
    }

    if (selectedPositions.length === 0) {
      setMessage({
        type: 'warning',
        text: 'Valitse vähintään yksi pelipaikka',
      })
      setIsSubmitting(false)
      return
    }

    const createdLists = []
    const failedPositions = []

    try {
      for (const selectedPosition of selectedPositions) {
        try {
          const response = await axios.post(
            '/api/candidates',
            {
              Name: selectedPosition,
              TeamType: teamType,
              Season: teamType === 'U21' ? parseInt(season) : null,
              Competition: teamType === 'U21' ? competition : null,
              Position: selectedPosition,
              Qualifier:
                teamType === 'MJ' && mjQualifier.trim()
                  ? mjQualifier.trim()
                  : undefined,
            },
            {
              headers: { 'x-oauth-token': user ? user.oauth_token : null },
            }
          )
          createdLists.push(response.data)
        } catch (error) {
          failedPositions.push(selectedPosition)
          console.error(
            `Failed to create candidate list for ${selectedPosition}:`,
            error
          )
        }
      }

      if (createdLists.length > 0) {
        onListCreated('candidate', createdLists)
      }

      if (failedPositions.length === 0) {
        setMessage({
          type: 'success',
          text: `${createdLists.length} ehdokaslistaa luotu!`,
        })
        resetForm()
        setTimeout(() => {
          handleClose()
        }, 1500)
      } else if (createdLists.length > 0) {
        setMessage({
          type: 'warning',
          text: `Luotiin ${
            createdLists.length
          } listaa. Epäonnistui: ${failedPositions.join(', ')}`,
        })
      } else {
        setMessage({
          type: 'danger',
          text: 'Yhdenkään listan luonti ei onnistunut',
        })
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleRequirementSubmit = async event => {
    event.preventDefault()
    setIsSubmitting(true)

    const newList = {
      name: name,
      age: parseInt(age),
    }

    const skills = {}
    if (keeperSkill) skills.keeperSkill = parseFloat(keeperSkill)
    if (defenderSkill) skills.defenderSkill = parseFloat(defenderSkill)
    if (playmakerSkill) skills.playmakerSkill = parseFloat(playmakerSkill)
    if (wingerSkill) skills.wingerSkill = parseFloat(wingerSkill)
    if (passingSkill) skills.passingSkill = parseFloat(passingSkill)
    if (scorerSkill) skills.scorerSkill = parseFloat(scorerSkill)
    if (setPiecesSkill) skills.setPiecesSkill = parseFloat(setPiecesSkill)

    if (Object.keys(skills).length > 0) {
      newList.skills = skills
    }
    if (htms) {
      newList.HTMS = parseFloat(htms)
    }

    // Tarkista että ainakin yksi kriteeri on annettu
    if (!htms && Object.keys(skills).length === 0) {
      setMessage({
        type: 'warning',
        text: 'Anna ainakin yksi taito tai HTMS-arvo',
      })
      setIsSubmitting(false)
      return
    }

    try {
      const response = await axios.post('/list/' + user.oauth_token, newList)
      setMessage({
        type: 'success',
        text: `Vaatimuslista "${response.data.Name}" luotu!`,
      })
      onListCreated('requirement', response.data)
      resetForm()
      setTimeout(() => {
        handleClose()
      }, 1500)
    } catch (error) {
      console.error('Failed to create requirement list:', error)
      setMessage({ type: 'danger', text: 'Virhe luotaessa vaatimuslistaa' })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header
        closeButton
        style={{ backgroundColor: '#2C2F33', color: '#FFFFFF' }}
      >
        <Modal.Title>Luo uusi lista</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: '#36393F', color: '#FFFFFF' }}>
        {message.text && (
          <Alert
            variant={message.type}
            onClose={() => setMessage({ type: '', text: '' })}
            dismissible
          >
            {message.text}
          </Alert>
        )}

        <Tabs
          activeKey={activeTab}
          onSelect={k => setActiveTab(k)}
          className="mb-3"
          variant="pills"
        >
          <Tab eventKey="candidate" title="Ehdokaslista">
            <div
              className="p-3"
              style={{ backgroundColor: '#2C2F33', borderRadius: '8px' }}
            >
              <p className="text-muted mb-3">
                Ehdokaslista on manuaalinen lista, jolle voit lisätä pelaajia
                pelaajan sivulta. Käytä tätä kun haluat seurata tiettyjä
                pelaajia.
              </p>
              <Form
                onSubmit={
                  isMultiCreateMode
                    ? handleCreateMultipleCandidates
                    : handleCandidateSubmit
                }
              >
                <div className="d-flex justify-content-end mb-3">
                  <Button
                    type="button"
                    variant={isMultiCreateMode ? 'info' : 'outline-info'}
                    size="sm"
                    onClick={() => setIsMultiCreateMode(!isMultiCreateMode)}
                  >
                    Luo monta listaa
                  </Button>
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Joukkuetyyppi</Form.Label>
                  <Form.Select
                    value={teamType}
                    onChange={e => setTeamType(e.target.value)}
                  >
                    <option value="U21">U21</option>
                    <option value="MJ">MJ</option>
                  </Form.Select>
                </Form.Group>

                {teamType === 'U21' && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Kausinumero</Form.Label>
                      <Form.Control
                        type="number"
                        value={season}
                        onChange={e => setSeason(e.target.value)}
                        placeholder="Esim. 87"
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Kisamuoto</Form.Label>
                      <div
                        style={{
                          display: 'flex',
                          backgroundColor: '#1E2124',
                          borderRadius: '5px',
                          overflow: 'hidden',
                          width: 'fit-content',
                        }}
                      >
                        <Button
                          variant={
                            competition === 'CC' ? 'info' : 'outline-secondary'
                          }
                          size="sm"
                          onClick={() => setCompetition('CC')}
                          style={{
                            borderRadius: 0,
                            border: 'none',
                            padding: '5px 20px',
                          }}
                        >
                          CC (MMK)
                        </Button>
                        <Button
                          variant={
                            competition === 'WC' ? 'info' : 'outline-secondary'
                          }
                          size="sm"
                          onClick={() => setCompetition('WC')}
                          style={{
                            borderRadius: 0,
                            border: 'none',
                            padding: '5px 20px',
                          }}
                        >
                          WC (MM)
                        </Button>
                      </div>
                    </Form.Group>
                  </>
                )}

                {teamType === 'MJ' && (
                  <Form.Group className="mb-3">
                    <Form.Label>Tarkenne (valinnainen)</Form.Label>
                    <Form.Control
                      type="text"
                      value={mjQualifier}
                      onChange={e => setMjQualifier(e.target.value)}
                      placeholder="Esim. kausi 87 projekti"
                      maxLength={120}
                    />
                  </Form.Group>
                )}

                {isMultiCreateMode ? (
                  <Form.Group className="mb-3">
                    <Form.Label>Pelipaikat</Form.Label>
                    <div
                      style={{
                        backgroundColor: '#1E2124',
                        borderRadius: '6px',
                        padding: '10px 12px',
                      }}
                    >
                      {CANDIDATE_POSITIONS.map(positionName => (
                        <div
                          key={positionName}
                          className="d-flex justify-content-between align-items-center py-1"
                        >
                          <span>{positionName}</span>
                          <Form.Check
                            type="checkbox"
                            checked={selectedPositions.includes(positionName)}
                            onChange={() => handlePositionToggle(positionName)}
                          />
                        </div>
                      ))}
                    </div>
                  </Form.Group>
                ) : (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Pelipaikka</Form.Label>
                      <Form.Select
                        value={position}
                        onChange={e => setPosition(e.target.value)}
                      >
                        <option value="GK">GK</option>
                        <option value="WB">WB</option>
                        <option value="ETWB">ETWB</option>
                        <option value="CD">CD</option>
                        <option value="CA">CA</option>
                        <option value="IM">IM</option>
                        <option value="W">W</option>
                        <option value="FW">FW</option>
                        <option value="FTW">FTW</option>
                        <option value="PNF">PNF</option>
                        <option value="TDF">TDF</option>
                        <option value="Muu">Muu (määritä itse)</option>
                      </Form.Select>
                    </Form.Group>

                    {position === 'Muu' && (
                      <Form.Group className="mb-3">
                        <Form.Label>Oma pelipaikka</Form.Label>
                        <Form.Control
                          type="text"
                          value={customPosition}
                          onChange={e => setCustomPosition(e.target.value)}
                          placeholder="Määritä pelipaikka"
                          required
                        />
                      </Form.Group>
                    )}
                  </>
                )}

                <Button
                  variant="success"
                  type="submit"
                  disabled={
                    isSubmitting ||
                    (!isMultiCreateMode &&
                      position === 'Muu' &&
                      !customPosition.trim()) ||
                    (isMultiCreateMode && selectedPositions.length === 0)
                  }
                >
                  {isSubmitting
                    ? 'Luodaan...'
                    : isMultiCreateMode
                    ? 'Luo ehdokaslistat'
                    : 'Luo ehdokaslista'}
                </Button>
              </Form>
            </div>
          </Tab>

          <Tab eventKey="requirement" title="Vaatimuslista">
            <div
              className="p-3"
              style={{ backgroundColor: '#2C2F33', borderRadius: '8px' }}
            >
              <p className="text-muted mb-3">
                Vaatimuslista etsii automaattisesti pelaajia, jotka täyttävät
                annetut kriteerit. Anna nimi, maksimi-ikä sekä ainakin yksi
                taito tai HTMS.
              </p>
              <Form onSubmit={handleRequirementSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <Form.Label>Listan nimi</Form.Label>
                      <Form.Control
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        placeholder="Anna vaatimuslistan nimi"
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Maksimi-ikä</Form.Label>
                      <Form.Control
                        type="number"
                        value={age}
                        onChange={e => setAge(e.target.value)}
                        placeholder="Esim. 21"
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-3">
                      <Form.Label>HTMS28</Form.Label>
                      <Form.Control
                        type="number"
                        value={htms}
                        onChange={e => setHTMS(e.target.value)}
                        placeholder="Esim. 5500"
                      />
                    </Form.Group>
                  </div>
                </div>

                <hr style={{ borderColor: '#4F545C' }} />
                <p className="text-muted mb-2">Taitovaatimukset (minimi):</p>

                <div className="row">
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Maalivahti
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={keeperSkill}
                        onChange={e => setKeeperSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Puolustus
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={defenderSkill}
                        onChange={e => setDefenderSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Pelinrakennus
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={playmakerSkill}
                        onChange={e => setPlaymakerSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Laituri
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={wingerSkill}
                        onChange={e => setWingerSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Syöttäminen
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={passingSkill}
                        onChange={e => setPassingSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Maalinteko
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={scorerSkill}
                        onChange={e => setScorerSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-3">
                    <Form.Group className="mb-2">
                      <Form.Label style={{ fontSize: '0.85rem' }}>
                        Erikoistilanteet
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={setPiecesSkill}
                        onChange={e => setSetPiecesSkill(e.target.value)}
                        size="sm"
                      />
                    </Form.Group>
                  </div>
                </div>

                <Button
                  variant="success"
                  type="submit"
                  className="mt-3"
                  disabled={isSubmitting || !name.trim() || !age}
                >
                  {isSubmitting ? 'Luodaan...' : 'Luo vaatimuslista'}
                </Button>
              </Form>
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: '#2C2F33' }}>
        <Button variant="secondary" onClick={handleClose}>
          Peruuta
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default CreateListModal
